import API from 'services/TAPS_API';

export default function getParsedFias() {
  return API.request({
    method: 'GET',
    url: `/egrn/get-parsed-address`,
    mapper: function (data) {
      return Object.assign({}, data, {
        regionCode: data.subjectCode, // код региона (2х-значный)
        postCode: data.zip, // Почтовый индекс
        region: data.subjectName, // Наименование субъекта РФ
        district: data.region, // Район
        houseNumber: data.building, // Номер дома
        buildingNumber: data.housing, // Номер корпуса
        apartmentNumber: data.apartment, // Номер квартиры
      });
    },
  });
}
